import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { ExportingModel } from '../models';

interface ExportPayload {
  readonly feature_name: 'order-export-transaction' | 'order-export-item-detail';
  readonly additional?: {
    start_time?: string;
    end_time?: string;
    outlet_id?: number | null; // null means all outlets
  };
}

const EXPORT_FILE_URL = `${MOKA_GOAUTH_SERVICE}/exporting/v1/exports`;
const GET_EXPORT_FILE_URL = (exportId: string) => `${EXPORT_FILE_URL}/${exportId}`;

async function exportFile(payload: ExportPayload, outletId: number | null): Promise<ExportingModel.ExportFile> {
  const { data } = await axios.post(EXPORT_FILE_URL, payload, { headers: { outlet_id: outletId } });

  return data;
}

async function getExportFile(exportId: string): Promise<ExportingModel.GetExportFile> {
  const { data } = await axios.get(GET_EXPORT_FILE_URL(exportId));

  return data;
}

export { EXPORT_FILE_URL, exportFile, getExportFile };
